// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import {
    NODE_BAR_WIDTH,
    SankeyLayoutNode,
} from 'admin/failoverDomain/page/components/SummaryCards/useSankeyLayout';
import { SankeyPill } from 'admin/failoverDomain/page/components/SummaryCards/SankeyPill';

interface ISankeyNodeProps {
    node: SankeyLayoutNode;
}

export const SankeyNode: React.FC<ISankeyNodeProps> = ({ node }) => {
    const barX = node.x0 ?? 0;
    const barTop = node.y0 ?? 0;
    const barBottom = node.y1 ?? 0;
    const nodeHeight = barBottom - barTop;

    return (
        <>
            {nodeHeight > 0 && (
                <rect x={barX} y={barTop} width={NODE_BAR_WIDTH} height={nodeHeight} fill={node.color} />
            )}
            <SankeyPill node={node} />
        </>
    );
};
